"use client";

import { isComingSoon } from "@/lib/coming-soon";
import { ComingSoonPage } from "@/components/coming-soon-page";
import { RegisterForm } from "./register-form";

export default function RegisterPage() {
    if (isComingSoon) return <ComingSoonPage />;
    return <RegisterForm />;
}
